module.exports = __webpack_public_path__ + "img/IMG_6070_L_BlackMatted_MockedUp.95b72896.jpg";